import { render, staticRenderFns } from "./CreateReturnReturnInfo.vue?vue&type=template&id=994d744c"
import script from "./CreateReturnReturnInfo.vue?vue&type=script&lang=js"
export * from "./CreateReturnReturnInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports